import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Box, CircularProgress } from '@mui/material';
import './utils/safeLocalStorage'; // Import this before App to ensure localStorage is safe
import './index.css';
import App from './App';

import { patchResizeObserver } from './utils/resizeObserverPolyfill';
import ErrorBoundary from './components/ErrorBoundary';

// Apply ResizeObserver patch to prevent loop errors
patchResizeObserver();

// Handle initial navigation for unauthenticated users
if (window.location.hash === '' || window.location.hash === '#/') {
  // Check if user has any auth tokens
  try {
    // Check for current token key (ev_charging_auth_tokens_v2) and legacy keys
    const hasAuth = localStorage.getItem('ev_charging_auth_tokens_v2') ||
                    localStorage.getItem('ev_auth_tokens') ||
                    localStorage.getItem('RaStore.auth');
    if (!hasAuth) {
      // Redirect to login before React Admin initializes
      window.location.hash = '#/login';
    }
  } catch (e) {
    // If localStorage fails, redirect to login
    window.location.hash = '#/login';
  }
}

// Loading fallback component
const LoadingFallback = () => (
  <Box
    sx={{
      display: 'flex',
      minHeight: '100vh',
      backgroundColor: '#F8F9FA',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress size={40} sx={{ color: '#009A75' }} />
  </Box>
);


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// In development, StrictMode can cause double-rendering issues
// Temporarily disable StrictMode to see if it's causing the infinite loop
if (import.meta.env.PROD) {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
          <App />
        </Suspense>
      </ErrorBoundary>
    </React.StrictMode>
  );
} else {
  root.render(
    <ErrorBoundary>
      <Suspense fallback={<LoadingFallback />}>
        <App />
      </Suspense>
    </ErrorBoundary>
  );
}

